import { AddNewButtonShell } from '@/components/RootScreenButtons/buildingBlocks/AddNewButtonShell';
import { useAppPush } from '@/hooks/useAppPush';
import useTranslation from '@/hooks/useTranslation';

export const AddNewPaymentButton = () => {
  const t = useTranslation();
  const { push } = useAppPush();
  return (
    <AddNewButtonShell
      onClick={() => {
        push('/payments/new');
      }}
    >
      {t('section.ADD_NEW_PAYMENT')}
    </AddNewButtonShell>
  );
};
